@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.popover {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  width: 228px;
  background-color: var(--glass-sidebar-background-color, var(--sidebar-background-color));

  @include for-phone-only {
    width: calc(100vw - 10px);
  }
}

.menuItem:has(.creditUsageContainer) {
  padding: 0;
}

.menuItem:has(.autoReloadContainer) {
  padding: 0;
}

.selectedWorkspace {
  color: var(--nav-item-color, var(--neutral-90));
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 6px;
  margin-bottom: 4px;

  [data-autopilot-system-redesign='on'] & {
    padding: 8px;
    margin-bottom: 0;
    gap: 14px;
    height: 56px;
  }

  .selectedWorkspaceInfo {
    @include line-clamp;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .selectedWorkspaceName {
    @include md-semibold;

    [data-autopilot-system-redesign='on'] & {
      @include xs-sohne-medium;
      color: var(--dark-90);
    }
  }

  .selectedWorkspaceMembers {
    @include sm-regular;

    [data-autopilot-system-redesign='on'] & {
      @include xs-sohne-book;
      color: var(--dark-40);
    }
  }
}

.profileButtonContainer {
  position: relative;
}

.profileButton {
  height: 40px;
  width: 40px;
  border-radius: 999px;
}

.avatar {
  border: 1px solid var(--light-100);
  position: absolute;
  right: -5px;
  bottom: 0;
}

.switchWorkspaceChevronRight {
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: flex-end;
}

.drawerContainer {
  display: flex;
  flex-direction: column;
  min-height: 0; // allow shrink so section content can scroll
  padding-top: 0 !important;
  background: var(--light-100);
  overflow: hidden; // contain scroll to .menuScrollWrapper
}

.trigger {
  cursor: pointer;
  display: flex;
  align-items: center;

  [data-autopilot-system-redesign='on'] & {
    height: 32px;
    width: 32px;
  }
}
